import { render, staticRenderFns } from "./BKConfirmationDialog.vue?vue&type=template&id=59102bd8&scoped=true"
import script from "./BKConfirmationDialog.vue?vue&type=script&lang=ts&setup=true"
export * from "./BKConfirmationDialog.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./BKConfirmationDialog.vue?vue&type=style&index=0&id=59102bd8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59102bd8",
  null
  
)

export default component.exports